export const FIELD_MAX_COUNT = 2000;

export const MAX_DROPDOWN_FIELD_COUNT = 100;

export const MAX_FIELD_COUNT_PER_AUTOFILL_GROUP = 50;
